module.exports = __webpack_public_path__ + "static/media/cruz-a.d5cd1c9b.png";